<template>
  <div id="roadmap" class="roadmap">
    <img class="image" src="../assets/roadmap.png" />
  </div>
</template>
<script>
export default {
  name: "Roadmap",
};
</script>
<style></style>
